import { HelmetDexteel } from "@dexteel/mesf-core";
import { OperatorsManager } from "./components/OperatorsManager";

export const OperatorsPage = () => {
	return (
		<>
			<HelmetDexteel title="Operators" />
			<OperatorsManager />
		</>
	);
};
